"use client";
import { cva as e } from "class-variance-authority";
const a = e("", {
  variants: {
    slot: {
      root: [
        "peer h-4 w-4 shrink-0 rounded-xs",
        "border-2 border-inherit cursor-pointer",
        "disabled:opacity-50",
        "data-[state=checked]:bg-gray-1000",
        "dark:data-[state=checked]:bg-white-alpha-950",
        "data-[state=checked]:border-gray-1000",
        "dark:data-[state=checked]:border-white-alpha-950",
        "text-white data-[state=checked]:text-white",
        "dark:data-[state=checked]:text-gray-1000"
      ],
      indicator: ["flex items-center justify-center", "text-current animate-checkbox-check"]
    }
  }
});
export {
  a as checkbox
};
